import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { SKILLS_KEY } from '~/hooks/queries/skills/skillsQueryKey';
import { PRIVATE_SKILL_KEY } from '~/hooks/queries/skills/usePrivateSkill';
import { PRIVATE_SKILLS_LIST_KEY } from '~/hooks/queries/skills/usePrivateSkillsList';
import { WORKSPACE_AGENT_SKILLS_LIST_KEY } from '~/hooks/queries/workspace-agent-skills/useWorkspaceAgentSkillsList';

export const useInvalidateSkillsCatalogQueries = () => {
  const queryClient = useQueryClient();

  const invalidateSkillsCatalogQueries = useCallback(
    () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: [PRIVATE_SKILLS_LIST_KEY] }),
        queryClient.invalidateQueries({ queryKey: [PRIVATE_SKILL_KEY] }),
        queryClient.invalidateQueries({ queryKey: [WORKSPACE_AGENT_SKILLS_LIST_KEY] }),
        queryClient.invalidateQueries({ queryKey: [SKILLS_KEY] }),
      ]),
    [queryClient],
  );

  return { invalidateSkillsCatalogQueries };
};
